import React, { FC, useState } from 'react';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { useIntl } from 'react-intl';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { useDispatch } from 'react-redux';
import { useDataProvider } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types/common-types';
import { AgentLeadSource } from 'src/app/modules/PulseLeads/types/agent-types';
import { AgentLeadSourceListParam, fetchAgentLeadSourceList } from 'src/app/modules/PulseLeads/network/agentCrud';
import AgentLeadSourceList from './components/AgentLeadSourceList';

type AgentLeadSourceListingPageProps = {} & ParamsProps;

const initialState: AgentLeadSourceListParam = {
  sourceName: '',
  sortBy: '',
  page: 1,
  limit: 5,
};

export const agentLeadSourceFilterKeys = ['sourceName'];

const paramsInitiator = (initialParams?: Record<string, string>): AgentLeadSourceListParam => {
  return initialParams
    ? {
        sourceName: initialParams.sourceName || '',
        sortBy: '',
        page: 1,
        limit: 5,
      }
    : initialState;
};

const AgentLeadSourceListingPage: FC<AgentLeadSourceListingPageProps> = ({ initialParams, onChangeQueryParams }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const dispatch = useDispatch();

  const [filterState, setFilterState] = useState<AgentLeadSourceListParam>(paramsInitiator(initialParams));
  const [agentLeadSourceList, setAgentLeadSourceList] = useState<PaginateList<AgentLeadSource>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<AgentLeadSource>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchAgentLeadSourceList(filterState, dispatch);
      } catch (err) {}
    },
    setAgentLeadSourceList,
    false,
  );
  return (
    <>
      <PruFilter
        title={Translation('pulseleads.agent.leadSource.filter')}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'sourceName',
            initialValue: filterState.sourceName,
            displayName: Translation('pulseleads.leadSource.common.name'),
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            sourceName: data.sourceName,
          })
        }
        fetchData={refreshData}
      />
      <AgentLeadSourceList
        isLoading={isLoading}
        agentLeadSourceList={agentLeadSourceList}
        onRefresh={refreshData}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default AgentLeadSourceListingPage;
